
(function(){
  function money(cents, currency){
    try { return new Intl.NumberFormat('fr-MA',{style:'currency',currency:currency||'MAD',maximumFractionDigits:2}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2)+' MAD'; }
  }
  function init(box){
    if(box.dataset.codReady) return;
    box.dataset.codReady='1';
    var unit=parseInt(box.dataset.unitPrice||'0',10);
    var currency=box.dataset.currency||'MAD';
    var offers=[].slice.call(box.querySelectorAll('.lm-offer'));
    var selected=box.querySelector('.lm-offer.is-selected')||offers[0];
    var totalEl=box.querySelector('[data-summary-total]');
    var offerEl=box.querySelector('[data-summary-offer]');
    var form=box.querySelector('[data-lm-cod-form]');
    var errorEl=box.querySelector('[data-cod-error]');

    function render(){
      offers.forEach(function(btn){
        var qty=parseInt(btn.dataset.qty,10)||1;
        var discount=parseInt(btn.dataset.discount,10)||0;
        var full=unit*qty;
        var total=full;
        var p=btn.querySelector('[data-price]');
        var old=btn.querySelector('[data-old-price]');
        if(p) p.textContent=money(total,currency);
        if(old) old.textContent=discount?money(full,currency):'';
        btn.classList.toggle('is-selected',btn===selected);
        btn.setAttribute('aria-pressed',btn===selected?'true':'false');
      });
      var qty=parseInt(selected.dataset.qty,10)||1;
      var discount=parseInt(selected.dataset.discount,10)||0;
      var total=unit*qty;
      if(offerEl) offerEl.textContent=qty+' '+(qty===1?'boîte':'boîtes');
      if(totalEl) totalEl.textContent=money(total,currency);
    }
    offers.forEach(function(btn){
      btn.addEventListener('click',function(){selected=btn;render();});
    });
    render();

    // Keep selected variant price/id in sync when Shopify changes variants.
    document.addEventListener('change',function(e){
      if(!box.contains(e.target) && (e.target.name==='id' || e.target.matches('[name="id"]'))){
        var id=e.target.value;
        if(!id) return;
        fetch('/products/'+(window.location.pathname.split('/products/')[1]||'').split('?')[0]+'.js')
          .then(function(r){return r.ok?r.json():null}).then(function(p){
            if(!p) return;
            var v=p.variants.find(function(x){return String(x.id)===String(id)});
            if(v){unit=v.price;box.dataset.variantId=v.id;render();}
          }).catch(function(){});
      }
    });

    form.addEventListener('submit',function(e){
      e.preventDefault();
      errorEl.hidden=true;
      var submit=form.querySelector('.lm-cod-submit');
      var data=new FormData(form);
      var name=(data.get('lm_name')||'').trim();
      var phone=(data.get('lm_phone')||'').trim();
      var city=(data.get('lm_city')||'').trim();
      var address=(data.get('lm_address')||'').trim();
      if(!name||!phone||!city||!address){
        errorEl.textContent='عافاك عمّر جميع الخانات المطلوبة.';
        errorEl.hidden=false; return;
      }
      var qty=parseInt(selected.dataset.qty,10)||1;
      var discount=parseInt(selected.dataset.discount,10)||0;
      var full=unit*qty;
      var total=Math.round(full*(100-discount)/100);
      submit.disabled=true;
      submit.querySelector('span').textContent='جاري تجهيز الطلب...';

      fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
      .then(function(){
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
          items:[{id:parseInt(box.dataset.variantId,10),quantity:qty,properties:{
            'العرض':qty+' '+(qty===1?'boîte':'boîtes'),
            'السعر قبل العرض':money(full,currency),
            'الخصم':discount+'%',
            'الاسم':name,
            'الهاتف':phone,
            'المدينة':city,
            'العنوان':address
          }}]
        })});
      })
      .then(function(r){if(!r.ok) throw new Error('add'); return r.json();})
      .then(function(){
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{
          'COD - الاسم':name,
          'COD - الهاتف':phone,
          'COD - المدينة':city,
          'COD - العنوان':address,
          'COD - العرض':qty+' boîtes',
          'COD - إجمالي العرض':money(total,currency)
        }})});
      })
      .then(function(){ window.location.href='/checkout'; })
      .catch(function(){
        submit.disabled=false;
        submit.querySelector('span').textContent='🛒 اطلب الآن — الدفع عند الاستلام';
        errorEl.textContent='وقع مشكل فإرسال الطلب. عاود المحاولة من فضلك.';
        errorEl.hidden=false;
      });
    });
  }
  function boot(){document.querySelectorAll('[data-lm-cod]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
